<template>
  <div v-if="recipe">
    <div class="container">
      <div class="single">
        <div class="single__header">
          <div class="single__header__content">
            <h1 class="single__title">{{ recipe.title }}</h1>
            <div class="single__metas">
              <RecipeMetas :recipe="recipe" />
            </div>
            <div class="single__actions">
              <div class="single__like single__action">
                <RecipeLove :showCount="true" :recipe="recipe" />
              </div>
              <div class="single__favorites single__action">
                <Favorite :recipe="recipe" />
              </div>
              <div v-if="false" class="single__share single__action">
                <Share :recipe="recipe" />
              </div>
            </div>
          </div>
          <div class="single__image" v-html="recipe.image"></div>
        </div>
        <div class="single__content">
          <aside class="single__aside">
            <div class="single__ingredients">
              <IngredientsList
                :recipe="recipe"
                :ingredients="recipe.ingredients"
                :nbPerson="recipe.nb_persons"
                @counter="count => this.changeCounter(count)"
              />
            </div>
            <div
              class="single__tip"
              v-if="recipe.tip"
              v-html="recipe.tip"
            ></div>
            <AuthorCard :author="recipe.author" />
          </aside>
          <main class="single__steps">
            <Steps
              :steps="recipe.steps"
              :nbPerson="recipe.nb_persons"
              :counter="counter"
            />
          </main>
        </div>
      </div>
      <div class="single__comments">
        <RecipeComments :recipe="recipe" />
      </div>
    </div>
  </div>
</template>
<script>
import Favorite from "@/components/recipe-actions/Favorite.vue";
import RecipeComments from "@/components/single/RecipeComments.vue";
import IngredientsList from "@/components/single/ingredient/IngredientList.vue";
import Steps from "@/components/single/Steps.vue";
import AuthorCard from "@/components/user/AuthorCard.vue";
import RecipeMetas from "@/components/single/RecipeMetas.vue";
import Share from "@/components/recipe-actions/Share.vue";
import RecipeLove from "@/components/recipe-actions/RecipeLove.vue";

export default {
  name: "RecipeSingle",
  components: {
    IngredientsList,
    Steps,
    AuthorCard,
    RecipeMetas,
    RecipeLove,
    RecipeComments,
    Share,
    Favorite
  },
  data() {
    return {
      recipe: false,
      metas: false,
      counter: false
    };
  },
  mounted() {
    this.fetchRecipe();
  },
  methods: {
    async fetchRecipe() {
      const found_recipe = this.$store.state.recipes.find(recipe => {
        return recipe.slug == this.$route.params.slug;
      });

      if (found_recipe) {
        this.recipe = found_recipe;
        this.counter = this.recipe.nb_persons;
        return null;
      }

      this.recipe = await this.getApi("recipe/" + this.$route.params.slug);
      this.$store.state.recipes.push(this.recipe);
      this.counter = this.recipe.nb_persons;
    },
    changeCounter(count) {
      this.counter = count;
    }
  }
};
</script>

<style lang="scss" scoped>
.single {
  margin-top: 30px;
  &__header {
    display: flex;
    position: relative;
    flex-direction: column-reverse;
    @include breakpoint(md-min) {
      flex-direction: row;
    }
    &__content {
      padding: 10px 0 0;
      @include breakpoint(lg-min) {
        padding: 20px 50px;
      }
      text-align: left;
      background: $white;
      z-index: 1;
      width: 100%;
      margin: 0px auto 0;
      @include breakpoint(md-min) {
        border: 1px solid $light-gray;
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 45%;
        padding: 20px 25px;
      }
    }
  }
  &__actions {
    margin-top: 20px;
    display: flex;
  }
  &__action {
    & + & {
      margin-left: 10px;
    }
  }
  &__ingredients {
    padding: 20px 30px 40px 30px;
  }

  &__aside {
    border: 1px solid $primary;
    border-radius: $box-radius;
    margin-top: 70px;
    background: $white;
    position: relative;
    z-index: 1;
    overflow: hidden;
    @include breakpoint(md-min) {
      width: (100% / 3);
      flex-shrink: 0;
    }
  }
  &__steps {
    background: $white;
    box-shadow: $box-shadow;
    border-radius: $box-radius;
    padding: 20px;
    margin-top: 20px;
    @include breakpoint(md-min) {
      width: calc(#{100% / 3 * 2} + 60px);
      padding: 70px 40px 40px 100px;
      flex-shrink: 0;
      position: relative;
      right: 60px;
    }
  }
  &__tip {
    background: rgba($black, 0.03);
    padding: 3px 15px;
    line-height: 1.33;
    color: rgba($black, 0.9);
    p {
      margin: 0;
    }
  }
  &__title {
    margin: 0;
    font-size: 36px;
    @include font-title();
  }
  &__image {
    width: 100%;
    ::v-deep * {
      display: block;
    }
    @include breakpoint(md-min) {
      width: 70%;
    }
    position: relative;
    &::before {
      content: "\0020";
      display: block;
      $px: 15px;
      @include absolute($px, $px, $px, $px);
      border: 2px solid $white;
    }
    &::v-deep img {
      width: 100%;
      height: auto;
    }
  }

  &__content {
    margin-top: 70px;
    @include breakpoint(md-min) {
      display: flex;
      align-items: flex-start;
    }
  }

  &__metas {
    margin-top: 10px;
  }
  &__comments {
    margin-bottom: 20px;
  }
}
</style>
